import { render, staticRenderFns } from "./ShowcaseSection.vue?vue&type=template&id=2a68afc8&scoped=true&"
import script from "./ShowcaseSection.vue?vue&type=script&lang=js&"
export * from "./ShowcaseSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a68afc8",
  null
  
)

export default component.exports